import React from 'react';
export var ReactReduxContext = React.createContext(null);
export default ReactReduxContext;